export default __webpack_public_path__ + "static/media/ai72-1-2.03e0a62b.jpg";